var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18433 6.125H5.18433H21.1843",
    stroke: "#FF4242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1843 6.125V20.125C19.1843 20.6554 18.9736 21.1641 18.5985 21.5392C18.2235 21.9143 17.7148 22.125 17.1843 22.125H7.18433C6.65389 22.125 6.14519 21.9143 5.77011 21.5392C5.39504 21.1641 5.18433 20.6554 5.18433 20.125V6.125M8.18433 6.125V4.125C8.18433 3.59457 8.39504 3.08586 8.77011 2.71079C9.14519 2.33571 9.65389 2.125 10.1843 2.125H14.1843C14.7148 2.125 15.2235 2.33571 15.5985 2.71079C15.9736 3.08586 16.1843 3.59457 16.1843 4.125V6.125",
    stroke: "#FF4242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.bbeca05ca3086ad18bc34098a3eff016.svg";
export { ForwardRef as ReactComponent };